import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const BrandKnowledgeLayout = lazy(() =>
  import(
    "@/features/brands/edit/components/knowledge/BrandKnowledgeLayout"
  ).then((m) => ({ default: m.BrandKnowledgeLayout })),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/brands/$brandId/knowledge",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { brandId } = Route.useParams();

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-16">Loading...</div>
      }
    >
      <BrandKnowledgeLayout brandId={Number(brandId)} />
    </Suspense>
  );
}
